export const debitCardContentBox = {
    showDisplayPinNavigation: true,
    showDisplayPanNavigation: true,
    showChangeCardLimitsNavigation: true,
};
